import { Box } from '@mui/material';
import { Card, CardContent } from '@portals/core/src/components/Card/Card';
import { Pill } from '@portals/core/src/components/Pill/Pill';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import React from 'react';

import { InfoCard as InfoCardModel } from '../../../models';
import { useLinkProps } from '../../hooks/useLinkProps';

export interface Props {
  node: InfoCardModel;
}

export const InfoCard: React.FunctionComponent<Props> = ({ node }: Props) => {
  const { linkProps, anchorProps } = useLinkProps(node.link[0]);

  return (
    <Card id={`${node.__contentType}.${node.id}`} {...linkProps} variant="info">
      <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {node.headline && (
          <Typography variant="h4" component={node.headline.component}>
            {node.headline.text}
          </Typography>
        )}
        <Box m={5} />
        {node.text && <Typography variant="body2">{node.text}</Typography>}
        <Box marginTop={10} marginBottom="auto" />
        {node.link && <Pill label={node.link[0]?.text} fullWidth={true} {...anchorProps} />}
      </CardContent>
    </Card>
  );
};
